import React, { FC, memo } from 'react';
import i18next from 'i18next';
import PrimaryButton from './PrimaryButton';

type Props = { callback: () => void, errorContent?: string };
const ErrorComponent: FC<Props> = ({ errorContent, callback }) => {

  return (<div className="bg-white w-100 vh-100 d-flex flex-row justify-content-center">
    <div className="d-flex flex-column justify-content-center align-items-center">
      <h2>{i18next.t('errorMessageTemplate.genericTitle')}</h2>
      <p className="mb-3">{errorContent || i18next.t('errorMessageTemplate.genericMsg')}</p>
      <PrimaryButton onClick={callback}>
        {i18next.t('errorMessageTemplate.retryButtonText')}
      </PrimaryButton>
    </div>
  </div>);

};

export default memo(ErrorComponent);
